<template>

  <v-app light>

    <v-toolbar app clipped-left fixed prominent dark color="teal darken-3">

      <v-btn icon @click.native="cancel">
        <v-icon>arrow_back</v-icon>
      </v-btn>

      <v-toolbar-title v-text="'Configurações'"></v-toolbar-title>

      <v-spacer></v-spacer>

    </v-toolbar>

    <v-content>

      <v-container fluid grid-list-lg>
        <v-layout row wrap>

          <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
            <v-card class="px-3 py-2">
              <v-card-title class="headline">
                Trocar Usuário
                <v-spacer />
                <v-icon large>supervisor_account</v-icon>
              </v-card-title>
              <v-card-text>
                Clique no botão abaixo para <strong>remover suas informações de autenticação</strong> e logar com outro usuário:
              </v-card-text>
              <v-card-actions class="hidden-sm-and-down">
                <v-spacer></v-spacer>
                <v-btn color="error" @click="cleanup">
                  <v-icon left>swap_horiz</v-icon>
                  Trocar Usuário
                </v-btn>
              </v-card-actions>
              <v-card-actions class="hidden-md-and-up">
                <v-btn color="error" block @click="cleanup">
                  <v-icon left>swap_horiz</v-icon>
                  Trocar Usuário
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
            <v-card class="px-3 py-2">
              <v-card-title class="headline">
                Contato
                <v-spacer />
                <v-icon large>chat</v-icon>
              </v-card-title>
              <v-card-text>
                Clique no botão abaixo para <strong>entrar em contato</strong> ou <strong>reportar algum problema técnico</strong>:
              </v-card-text>
              <v-card-actions class="hidden-sm-and-down">
                <v-spacer></v-spacer>
                <v-btn color="info" @click="email">
                  <v-icon left>mail</v-icon>
                  Enviar e-Mail
                </v-btn>
              </v-card-actions>
              <v-card-actions class="hidden-md-and-up">
                <v-btn color="info" block @click="email">
                  <v-icon left>mail</v-icon>
                  Enviar e-Mail
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
            <p class="body-2 text-xs-center">Versão {{ version }}</p>
          </v-flex>

        </v-layout>
      </v-container>

    </v-content>

    <confirm-wrapper ref="confirm" />

    <dialog-wrapper ref="dialog" />

  </v-app>

</template>

<script>
import ConfirmWrapper from '../components/Confirm.vue'
import DialogWrapper from '../components/Dialog.vue'

import UtilHelper from '../helpers/util'

var settings = require('../settings/' + process.env.NODE_ENV + '.json')
var pkg = require('../../package.json')

export default {
  components: {
    ConfirmWrapper,
    DialogWrapper
  },
  mixins: [
    UtilHelper
  ],
  data () {
    return {
      version: pkg.version
    }
  },
  beforeCreate () {
    if (!this.$localStorage.get('user').authenticated) {
      this.$router.push('/')
    }
  },
  methods: {
    cancel () {
      this.$router.push({ path: '/home' })
    },
    email () {
      window.open('mailto: ' + settings.support + '?subject=Problemas%20na%20vers%C3%A3o%20' + this.version + '%20do%20Custobov', '_blank')
    },
    cleanup () {
      this.$refs.confirm.open(
        'Trocar Usuário',
        'As suas simulações só ficam disponíveis quando você está logado em sua conta. Você quer mesmo sair?',
        {color: 'info'}).then(confirm => {
        if (confirm) {
          this.$localStorage.set('synchronized', 0)
          this.$localStorage.set('user', {
            authenticated: false,
            name: '',
            email: '',
            picture: '',
            token: ''
          })
          this.$localStorage.remove('vue-authenticate.vueauth_token')
          this.$db.simulation.clear()
          this.$router.push('/')
        }
      })
    }
  }
}
</script>
